export const { default: IconLogo } = require('../resources/images/thaihealth-logo.svg')
export const { default: Guide } = require('../resources/images/guide.svg')
export const { default: Component } = require('../resources/images/component.svg')
export const { default: Tools } = require('../resources/images/tools.svg')
export const { default: Search } = require('../resources/images/search.svg')
export const { default: Discord } = require('../resources/images/discord.svg')
export const { default: Design } = require('../resources/images/design.svg')
export const { default: Extension } = require('../resources/images/extension.svg')
export const { default: Gitee } = require('../resources/images/gitee.svg')
export const { default: LightOn } = require('../resources/images/light-on.svg')
export const { default: LightOff } = require('../resources/images/light-off.svg')
export const { default: Rtl } = require('../resources/images/rtl.svg')
export const { default: Ltr } = require('../resources/images/ltr.svg')
export const { default: Avatar } = require('../resources/images/avatar-user.svg')
export const { default: Light } = require('../resources/images/light.svg')
export const { default: Dark } = require('../resources/images/dark.svg')
export const { default: More } = require('../resources/images/more.svg')
export const { default: Language } = require('../resources/images/language.svg')

export const { default: Logo } = require('../resources/images/ThaiHealth-1.jpg')
export const { default: Logo2 } = require('../resources/images/ThaiHealth-2.png')
export const { default: LoadingBG } = require('../resources/images/ThaiHealth-bk.jpeg')
export const { default: EgrantingProcess } = require('../resources/images/egranting-process.png')
export const { default: EgrantingNanme } = require('../resources/images/egranting-nanme.png')
export const { default: LandingBG } = require('../resources/images/egranting-landing-bk.jpeg')
export const { default: EgrantingInfo } = require('../resources/images/egranting-info.jpeg')
